import { Button, CircleExclamationIcon, Typography } from '@execonline-inc/execonline-ui';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { T } from '../../../../../../../../Translations';

function ExperienceAction() {
  const [hover, setHover] = useState(false);

  return (
    <div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {when(hover, true)
        .map(() => (
          <div className="flex items-center gap-x-2 py-2 px-5">
            <CircleExclamationIcon size="md" color="amber" />
            <Typography color="amber" variant="caption">
              <T kind="You can not enroll in Preview Mode" />
            </Typography>
          </div>
        ))
        .getOrElse(() => (
          <Button color="gray" fullWidth>
            <T kind="Enroll" />
          </Button>
        ))}
    </div>
  );
}

export default observer(ExperienceAction);
